module.exports = __webpack_public_path__ + "static/media/cooperate.b784b09b.svg";